<template>
  <div class="container">
    <Transition name="fade">
      <div v-if="showModal" class="share-backdrop" @click="closeModal" />
    </Transition>
    <Transition :name="transitionName">
      <div v-if="showModal" class="share-modal-container">
        <div class="share-modal-cancel" @click="closeModal">
          <i class="icon material-icons">
            close
          </i>
        </div>
        <div class="share-modal-title">
          {{ $t('COMMON.SHARE') }}
        </div>
        <div>
          <SocialShare
            :title="article.subject"
            :cover="article.cover"
            :share-link="shareLink"
            :share-link-label="shareText"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import SocialShare from '@/components/common/SocialShare'
// import SocialShareLink from '@/components/common/SocialShareLink'

export default {
  name: 'ArticleSocialShareModal',
  components: {
    // SocialShareLink,
    SocialShare
  },
  directives: {},
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    article: {
      type: Object,
      default: () => {
        return {}
      }
    },
    articlePath: {
      type: String,
      default: 'articles' // articles or periodicalArticles
    }
  },
  data() {
    return {}
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth
    },
    transitionName() {
      return this.clientWidth < 768 ? 'fade' : 'slide-down'
    },
    shareLink() {
      return this.article && this.article.id
        ? `${window.location.protocol}//${window.location.host}/${this.$i18n.localePath()}/${this.articlePath}/${this.article.id}`
        : ''
    },
    shareText() {
      return this.$t('COMMON.SHARE_LINK')
    }
  },
  watch: {
    showModal(newValue) {}
  },
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
    closeModal() {
      this.$emit('closeSocialShareModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.share-backdrop {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  transition: opacity 300ms ease-in-out;
  overflow-y: hidden;
}
.share-modal {
  &-container {
    z-index: 101;
    position: fixed;
    left: calc((100% - 687px) / 2);
    top: 120px;
    height: 482px;
    width: 687px;
    margin: 0 auto;
    padding: 0 48px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
    overflow-x: hidden;
    overflow-y: hidden;
  }
  &-cancel {
    position: absolute;
    top: 36px;
    right: 36px;
    font-size: 24px;
    color: $grey-9b;
    cursor: pointer;
  }
  &-title {
    margin-top: 56px;
    margin-bottom: 36px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
  }
  &-loader {
    text-align: center;
  }
  &-preview {
    .article {
      width: 100%;
      margin-bottom: 36px;
      height: 108px;
      .cover,
      .info {
        display: inline-block;
        vertical-align: top;
        text-decoration: none;
        outline: none;
      }
      .cover {
        float: left;
        width: 205px;
        height: 108px;
        margin-right: 24px;
        border-radius: 4px;
        background-color: $grey-ec;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .info {
        float: left;
        width: calc((100% - 205px) - 24px);
        .subject {
          display: block;
          height: 64px;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          color: $grey-50;
          text-align: left;
          text-decoration: none;
          @include ellipsis-with-lines(2);
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .share-modal {
    &-container {
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: 0l;
      padding: 0 16px;
      border-radius: 0;
    }
    &-cancel {
      position: absolute;
      top: 24px;
      right: 24px;
    }
    &-title {
      margin-bottom: 49px;
    }
    &-preview {
      .article {
        display: block;
        width: 100%;
        margin-bottom: 24px;
        .cover {
          width: 110px;
          height: 110px;
          margin-right: 16px;
        }
        .info {
          width: calc((100% - 110px) - 16px);
        }
      }
    }

  }
}
</style>
